import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-projects-one',
  templateUrl: './projects-one.component.html',
  styleUrls: ['./projects-one.component.scss']
})
export class ProjectsOneComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
